import React from 'react'

import { AppGatePage, AppGatePageProps } from './AppGatePage'

/** Fábrica de página-gate estática: `export default makeGatePage({...})`. */
export function makeGatePage(props: AppGatePageProps) {
  function GatePage() {
    return <AppGatePage {...props} />
  }
  return GatePage
}
